import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PageAction } from '../../models/menu-item.model';

@Component({
  selector: 'app-page-actions-menu',
  templateUrl: './page-actions-menu.component.html',
  styleUrls: ['./page-actions-menu.component.scss'],
})
export class PageActionsMenuComponent {
  @Input() label = 'Ações';
  @Input() actions: PageAction[] = [];
  @Output() actionClick = new EventEmitter<string>();
}
